import { defineMessages } from 'react-intl';

export default defineMessages({
  claimNumber: {
    id: 'expert_search_bar.claim_number',
  },
  victimCIN: {
    id: 'expert_search_bar.victim_cin',
  },
  missionReference: {
    id: 'expert_search_bar.mission_reference',
  },
  searchTitle: {
    id: 'expert_search_container.title',
  },
  searchSubTitle: {
    id: 'expert_search_container.subtitle',
  },
});
